import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Grid,
  Box, Tooltip
} from "@mui/material";
import Image from "../../../src/assests/images/product-gal.png";
import countgallery from "../../../src/assests/images/count-gallery.svg";
import PaginationComponent from "./Pagination";
import { useLocation, useNavigate } from "react-router-dom";

interface ProductCardProps {
  branddetails: any[];
  page: any;
  limit: any;
  setPage: (page: number) => void;
  totalPages: number;
}
type ProductStatus = "PENDING_APPROVAL" | "APPROVED" | "REJECTED";

const ProductCard: React.FC<ProductCardProps> = ({
  branddetails,
  page,
  limit,
  setPage,
  totalPages,
}) => {
  const [showMore, setShowMore] = useState<Record<number, boolean>>({});

  const toggleShowMore = (id: number) => {
    setShowMore((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const navigate = useNavigate();



  const location = useLocation();
  const [imagedataValue, setimageDataValue] = useState("");
  const [idvalue, setid] = useState('');

  useEffect(() => {
    if (location.state?.sectionscountsectionscount) {
      console.log(
        location.state?.sectionscountsectionscount,
        "location.state?.imageDatalocation.state?.sectionscountsectionscount"
      );
      setimageDataValue(location.state.sectionscountsectionscount);
    }
  }, []);

  const handleCardClick = (id: number) => {
    console.log("Clicked Product IDbannerrrr:", id);
    setid(String(id));
    navigate(`/edit-brand/${id}`);
  };

  const statusLabels: Record<ProductStatus, string> = {
    PENDING_APPROVAL: "Pending For Approval",
    APPROVED: "Approved By abc@gmail.com",
    REJECTED: "Rejected",
  };

  const statusStyles: Record<ProductStatus, { background: string; color: string }> = {
    PENDING_APPROVAL: {
      background: "#FBF3E0",
      color: "#CA8501",
    },
    APPROVED: {
      background: "#EBF7E6",
      color: "#22683E",
    },
    REJECTED: {
      background: "#FFEBEE",
      color: "#C62828",
    },
  };


  console.log(branddetails, "branddetailsdddddddddddddddddd")

  return (
    <>
      <Box sx={{ padding: "30px 32px", marginTop: "0px", background: "#F9FBFC" }}>
        <Grid container spacing={3} justifyContent="left">
          {branddetails.map((product: any) => (
            <Grid item xs={12} sm={6} md={4} key={product.id}>
              <Card onClick={
                product.status === "APPROVED" || product.status === "REJECTED"
                  ? () => handleCardClick(product.id)
                  : undefined
              } sx={{
                borderRadius: 4, boxShadow: 3, padding: "0", position: "relative", cursor:
                  product.status === "APPROVED" || product.status === "REJECTED"
                    ? "pointer"
                    : "default",
              }}>
                <Box sx={{ height: "155px" }}>
                  <CardMedia
                    crossOrigin="anonymous"
                    component="img"
                    image={`${process.env.REACT_APP_API_URL}/uploads/${product.image}`}
                    alt={product.title}
                    sx={{
                      height: "100%",
                      width: "100%",
                      objectFit: "cover",     // ensures it covers the box
                      objectPosition: "top",  // aligns the image content to the top
                    }}
                  />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", padding: "6px", borderRadius: "8px", background: "rgba(0, 23, 57, 0.40)", fontSize: "14px", fontWeight: "500", color: "#FFF", position: "absolute", top: "32%", right: "30px", transform: "translate(50%, -50%)", }}>
                  <img src={countgallery} alt="countgallery" />
                  +{product.multiple_brand_images_count}
                  {/* +2 */}
                </Box>
                <CardContent sx={{ padding: "0 !important" }}>
                  <Box sx={{ padding: "15px" }}>
                    <Typography
                      variant="h6"
                      component="div"
                      gutterBottom
                      sx={{ fontWeight: "600", fontSize: "18px" }}
                    >
                      {product.title}
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        fontSize: "16px",
                      }}
                    >
                      <Typography variant="body1">
                        10s pack: <strong>{product.price10}</strong>
                      </Typography>
                      <Typography variant="body1">
                        20s pack: <strong>{product.price20}</strong>
                      </Typography>
                    </Box>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                      sx={{
                        fontSize: "16px",
                        margin: "20px 0",
                        borderBottom: "1px dashed #000",
                        paddingBottom: "10px", display: 'flex'
                      }}
                    >
                      <Typography>Location:</Typography>
                      <Box
                        sx={{
                          fontSize: "16px",
                          margin: "2px 0 0 10px",
                          fontWeight: 600,
                          paddingBottom: "10px",
                        }}
                      >

                        {(() => {
                          const locations = product.location?.split(",") || [];
                          const firstThree = locations.slice(0, 3).join(", ");
                          const remaining = locations.slice(3).join(", ");
                          return (
                            <>
                              {firstThree}
                              {locations.length > 3 && (
                                <Tooltip title={remaining}>
                                  <Typography
                                    component="span"
                                    sx={{ cursor: "pointer", marginLeft: "5px", fontSize: "14px", color: "#B90022" }}
                                  >
                                    More +{locations.length - 3}
                                  </Typography>
                                </Tooltip>
                              )}
                            </>
                          );
                        })()}
                      </Box>
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: "16px" }}
                    >
                      Uploaded on: {product.date}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{

                      textAlign: "center",
                      padding: "5px 0",
                      ...(statusStyles[product.status as ProductStatus] || {}),
                    }}
                  >
                    {statusLabels[product.status as ProductStatus] || ""}

                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ borderTop: "1px solid #E4E7EC", }}>
        <PaginationComponent
          page={page}
          limit={limit}
          setPage={setPage}
          totalPages={totalPages}
        />
      </Box>
    </>
  );
};

export default ProductCard;
